import React, { useState } from "react";
import Logo from "../../../assets/logo.png";
import styles from "./style.module.scss";

const DEV_PASSWORD = "Summer2026";
const STORAGE_KEY = "canco-dev-password-verified";

const isDevEnvironment = () => {
  return process.env.REACT_APP_ENV === "dev";
};

const hasVerifiedSession = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

const DevPasswordProtection = ({ children }) => {
  const [isVerified, setIsVerified] = useState(hasVerifiedSession);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  if (!isDevEnvironment() || isVerified) {
    return children;
  }

  const submitHandler = (event) => {
    event.preventDefault();

    if (password === DEV_PASSWORD) {
      try {
        sessionStorage.setItem(STORAGE_KEY, "true");
      } catch {
        // sessionStorage can be unavailable in restricted browser modes.
      }
      setIsVerified(true);
      return;
    }

    setError("Incorrect password. Please try again.");
  };

  return (
    <div className={styles.page}>
      <div className={styles.glow} aria-hidden="true" />
      <div className={styles.content}>
        <img src={Logo} alt="Canco Petroleum" className={styles.logo} />
        <section className={styles.panel} aria-labelledby="dev-password-title">
          <p className={styles.eyebrow}>Development Environment</p>
          <h1 id="dev-password-title">Password Protected</h1>
          <p className={styles.description}>
            Enter the development password to continue to the Canco website.
          </p>
          <form onSubmit={submitHandler} className={styles.form}>
            <label htmlFor="dev-password">Password</label>
            <input
              id="dev-password"
              type="password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                setError("");
              }}
              autoComplete="current-password"
              autoFocus
              placeholder="Enter password"
            />
            {error && (
              <p className={styles.error} role="alert">
                {error}
              </p>
            )}
            <button type="submit">Continue</button>
          </form>
        </section>
      </div>
    </div>
  );
};

export default DevPasswordProtection;
